import { Tabs, Swiper } from 'antd-mobile';
import styled, { css } from 'styled-components';

export const CTabs = styled(Tabs)`
  .adm-tabs-tab {
    padding: 14px !important;
    font-size: 13px !important;
    font-weight: 600;
  }

  .adm-tabs-tab-list {
    overflow-y: hidden;
  }
`;

export const CSwiper = styled(Swiper)<{ isProductTabActive?: boolean }>`
  contain: layout;

  ${p =>
    p.isProductTabActive &&
    css`
      overflow: inherit;
    `};
`;
